const STYLE_ID = "lytra-feedback-note";

export const FEEDBACK_CONTEXT_NOTE = {
  de: "Ticket und technische Details haben wir, beschreiben Sie nur das Problem.",
  en: "We have the ticket and technical details, just describe the problem.",
} as const;

export function feedbackContextNote(language: string | undefined): string {
  const base = (language ?? "de").slice(0, 2).toLowerCase();
  return base === "en" ? FEEDBACK_CONTEXT_NOTE.en : FEEDBACK_CONTEXT_NOTE.de;
}

type StyleHost = {
  querySelector: (selectors: string) => Element | null;
  appendChild: (node: Node) => Node;
};

function isStyleHost(value: unknown): value is StyleHost {
  return (
    typeof value === "object" &&
    value !== null &&
    typeof (value as StyleHost).querySelector === "function" &&
    typeof (value as StyleHost).appendChild === "function"
  );
}

function cssString(text: string): string {
  return `"${text.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\r?\n/g, " ")}"`;
}

export function insertFeedbackContextNote(host: unknown, text: string): void {
  if (!isStyleHost(host) || !text) return;

  host.querySelector(`#${STYLE_ID}`)?.remove();

  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
    h2.dialog__header {
      flex-wrap: wrap;
    }
    h2.dialog__header::after {
      content: ${cssString(text)};
      flex: 0 0 100%;
      margin-top: 8px;
      font-size: var(--font-size, 14px);
      font-weight: 400;
      line-height: 1.4;
      color: #6b7280;
      white-space: normal;
    }
  `;
  host.appendChild(style);
}
